(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ssl-certificate-tool"] = factory();
	else
		root["ssl-certificate-tool"] = factory();
})(globalThis, () => {
return 